<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :show-close="showClose" :close-on-press-escape="closeOnPressEscape"
      :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="10px" :z-index="2000" :before-close="handleClose"
      @open="onDialogOpen">
      <template #title>
        <span>{{`课程${studentActiveQuestionnaires.StudentCourse.CourseName} - 老师${studentActiveQuestionnaires.StudentCourse.TeacherName}`}}</span>
      </template>
      <div class="backgroud-white cs-editor-content" v-loading="loading">
        <el-tabs key="tabs" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" type="border-card" v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane v-for="(questionnaire, questionnaireIndex) in studentActiveQuestionnaires.ActiveQuestionnaires" :key="questionnaireIndex"
            :label="questionnaire.data.Name || '问卷调查'" :name="`${questionnaire.data.Index}`">
            <div>{{ questionnaire.data.Description }}</div>
            <template v-for="(question, questionIndex) in questionnaire.data.Questions">
              <cs-question :key="questionIndex" :questionType="question.data.QuestionType" :index="question.data.Index" :title="question.data.Title"
                :annotation="question.data.Annotation" :isMultiple="question.data.IsMultiple" :isCustomized="question.data.IsCustomized"
                :min="question.data.Min" :max="question.data.Max" :options="question.AnswerOptionsEx" :errorMessage="question.ErrorMessage"
                v-model="question.Value" />
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row>
            <el-col>
              <el-button :disabled="readonly || loading || isSaving" :loading="isSaving" type="primary" @click="saveChanges">保存</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentActiveQuestionnaires,
  saveStudentQuestionnaireRecords,
} from "@/service/questionnaire.service";

const default_dataModel = {
  studentId: 0,
  courseId: 0,
  termId: 0,
};

const default_studentActiveQuestionnaires = {
  StudentCourse: {},
  ActiveQuestionnaires: [],
};

const mixinGeneralMethods = {
  methods: {
    validate() {
      let isValid = true;

      for (
        let i = 0;
        i < this.studentActiveQuestionnaires.ActiveQuestionnaires.length;
        i++
      ) {
        let questionnaire =
          this.studentActiveQuestionnaires.ActiveQuestionnaires[i];

        if (!questionnaire.validate()) {
          isValid = false;
          this.activeTabName = `${questionnaire.data.Index}`;
          this.$message.error(`[${questionnaire.data.Name}] 未填写完毕。`);
          break;
        }
      }

      return isValid;
    },
    scrollTop() {
      let refTabs = this.$vueRefStore.getChildrenRef("tabs");
      if (!!refTabs) {
        let jqTabsContent = $(refTabs.$el).find(".el-tabs__content");
        jqTabsContent.animate({ scrollTop: 0 });
      }
    },
  },
};

export default {
  name: "studentQuestionnaireEditor",
  mixins: [mixinGeneralMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "70%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      loading: false,
      isSaving: false,
      dialogVisible: false,
      studentActiveQuestionnaires: Object.clone(
        default_studentActiveQuestionnaires
      ),
      activeTabName: null,
      model: Object.clone(default_dataModel),
    };
  },
  created() {
    this.reloadVisible();
  },
  methods: {
    async loadStudentActiveQuestionnairesFromServer() {
      let studentId = this.model.studentId;
      let courseId = this.model.courseId;
      let termId = this.model.termId;
      try {
        let result = await getStudentActiveQuestionnaires(
          studentId,
          courseId,
          termId
        );

        this.studentActiveQuestionnaires =
          !!result && result.success
            ? result.data
            : Object.clone(default_studentActiveQuestionnaires);

        if (!!this.studentActiveQuestionnaires.StudentCourse) {
          this.studentActiveQuestionnaires.StudentCourse.TeacherName =
            `${this.studentActiveQuestionnaires.StudentCourse.TeacherName}`.lTrim(
              "老师"
            );
        }
        if (this.studentActiveQuestionnaires.ActiveQuestionnaires.length > 0) {
          this.activeTabName = `${this.studentActiveQuestionnaires.ActiveQuestionnaires[0].data.Index}`;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async saveStudentVipCourseRecordToServer() {
      this.isSaving = true;

      let studentId = this.model.studentId;
      let courseId = this.model.courseId;
      let termId = this.model.termId;
      let saveData = this.studentActiveQuestionnaires.ActiveQuestionnaires.map(
        (item) =>
          item.createStudentQuestionnaireRecord(studentId, courseId, termId)
      );

      try {
        let result = await saveStudentQuestionnaireRecords(saveData);
        if (!!result && result.success) {
          this.$message({
            message: "问卷调查保存成功。",
            type: "success",
          });

          return true;
        } else {
          this.$message({
            message: result.message || "问卷调查保存失败。",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }

      return false;
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    resetData() {
      this.model = Object.clone(default_dataModel);
      this.studentActiveQuestionnaires = Object.clone(
        default_studentActiveQuestionnaires
      );
      this.activeTabName = null;
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;
    },
    async showDialog(studentId, courseId, termId = 0) {
      this.model.studentId = studentId;
      this.model.courseId = courseId;
      this.model.termId = termId;

      await this.loadStudentActiveQuestionnairesFromServer();
      if (this.studentActiveQuestionnaires.ActiveQuestionnaires.length === 0) {
        this.$emit("completed");
        return;
      }

      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    async closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(() => {
        this.resetData();

        this.closeDialog();
      });
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.$nextTick(async () => {
        let result = await this.saveStudentVipCourseRecordToServer();
        if (result) {
          this.$emit("completed");
          this.closeDialog();
        }
      });
    },

    handleTabClick() {
      this.$nextTick(() => {
        this.scrollTop();
      });
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow-y: hidden;
  /deep/ .editor-dialog {
    min-width: 400px;
    height: calc(100% - 20px);

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }

    .el-dialog__body{
      padding-bottom: 5px;
      height: calc(100% - 130px);
    }

    .el-dialog__footer{
      .dialog-footer{
        margin-top: 0;
      }
    }
  }
}

.cs-editor-content {
  padding: 0 5%;
  height: 100%;
}

.el-tabs {
  height: 100%;

  /deep/ .el-tabs__content {
    height: calc(100% - 40px);
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/studentQuestionnaireEditor.vue